import type { Access } from './types';

export function normalizeAccess(raw: unknown): Access | null {
  if (!raw || typeof raw !== 'object') return null;
  const item = raw as Record<string, unknown>;
  if (typeof item.location !== 'string') return null;

  return {
    location: item.location,
    location_ascend_id:
      typeof item.location_ascend_id === 'string' ? item.location_ascend_id : null,
    role: typeof item.role === 'string' ? (item.role as Access['role']) : 'staff',
    permissions: Array.isArray(item.permissions)
      ? (item.permissions.filter((p) => typeof p === 'string') as Access['permissions'])
      : [],
    plans: Array.isArray(item.plans) ? (item.plans as Access['plans']) : [],
    credits: Array.isArray(item.credits) ? (item.credits as Access['credits']) : [],
  };
}
